import type { ConstsConfig } from '../declare'

const batchTextInputDefault = [
  { name: 'BATCH_TEXTINPUT_UPDATE', label: '修改为', value: 1 }
]

const batchTextInputClear = [
  { name: 'BATCH_TEXTINPUT_CLEAR', label: '清空', value: 2 }
]

const batchTextInput = [
  { name: 'BATCH_TEXTINPUT_ADD_BEFORE', label: '在开始添加', value: 11 },
  { name: 'BATCH_TEXTINPUT_ADD_AFTER', label: '在结束添加', value: 12 },
  { name: 'BATCH_TEXTINPUT_REPLACE', label: '替换', value: 13 },
]

const batchDateDay = [
  { name: 'BATCH_DATE_DAY_PLUS_DAY', label: '增加天数', value: 21 },
  { name: 'BATCH_DATE_DAY_PLUS_MONTH', label: '增加月数', value: 22 },
  { name: 'BATCH_DATE_DAY_PLUS_YEAR', label: '增加年数', value: 23 },
  { name: 'BATCH_DATE_DAY_SUB_DAY', label: '减少天数', value: 24 },
  { name: 'BATCH_DATE_DAY_SUB_MONTH', label: '减少月数', value: 25 },
  { name: 'BATCH_DATE_DAY_SUB_YEAR', label: '减少年数', value: 26 },
]

const consts: ConstsConfig[] = [
  {
    name: 'BATCH_TEXTINPUT_UPDATES',
    value: batchTextInputDefault
  },
  ...batchTextInputDefault,
  {
    name: 'BATCH_TEXTINPUT_CLEARS',
    value: batchTextInputClear
  },
  ...batchTextInputClear,
  {
    name: 'BATCH_TEXTINPUT_OPERATES',
    value: batchTextInput
  },
  ...batchTextInput,
  {
    name: 'BATCH_DATE_DAYS',
    value: batchDateDay
  },
  ...batchDateDay,
  // 保存按钮页面位置
  {
    name: 'PAGE_BTN_LOCATE_TOP',
    value: 0
  },
  {
    name: 'PAGE_BTN_LOCATE_BOTTOM',
    value: 1
  },
  // 页面配置列默认列数
  {
    name: 'PAGE_COL_NUMBER',
    value: 2
  },
]

export default consts